var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import moment from "moment";
import { injectIntl } from "@irati/utils/lang";
import { userDOBExists, userDOBIsWithinRedemptionWindow, getEarliestRedemptionDate } from "@irati/deals/helpers/deals/redemptionEvents/dateOfBirth";
import DateOfBirthRequiredBlock from "./DateOfBirthRequiredBlock";
import PerkNotAvailableBlock from "./PerkNotAvailableBlock";
import PerkAvailableBlock from "./PerkAvailableBlock";
import { Background, Wrapper } from "./styled";
var renderBlock = function (props) {
    var deal = props.deal, buttonText = props.buttonText, buttonDisabled = props.buttonDisabled, emoji = props.emoji, onClick = props.onClick;
    if (userDOBExists() && userDOBIsWithinRedemptionWindow(deal)) {
        return (React.createElement(PerkAvailableBlock, { redeemHeaderEmoji: emoji, redeemButtonText: buttonText, redeemButtonDisabled: !!buttonDisabled, onClickRedeem: onClick }));
    }
    else if (userDOBExists() && !userDOBIsWithinRedemptionWindow(deal)) {
        var today = moment();
        var earliestRedemptionDate = getEarliestRedemptionDate(deal);
        var date = moment(earliestRedemptionDate).isBefore(today)
            ? moment(earliestRedemptionDate).add(1, "y")
            : earliestRedemptionDate;
        return (React.createElement(PerkNotAvailableBlock, { availableDate: date, redeemHeaderEmoji: emoji, redeemButtonText: buttonText, redeemButtonDisabled: !!buttonDisabled, onClickRedeem: onClick }));
    }
    else {
        return React.createElement(DateOfBirthRequiredBlock, null);
    }
};
var RedemptionEventImportantInfo = /** @class */ (function (_super) {
    __extends(RedemptionEventImportantInfo, _super);
    function RedemptionEventImportantInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RedemptionEventImportantInfo.prototype.render = function () {
        return (React.createElement(Background, null,
            React.createElement(Wrapper, null, renderBlock(this.props))));
    };
    RedemptionEventImportantInfo.defaultProps = {
        emoji: ""
    };
    return RedemptionEventImportantInfo;
}(PureComponent));
export default injectIntl(RedemptionEventImportantInfo);
